/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { Component } from 'react';
import {
    object, array, string, func, number, bool, arrayOf, shape,
} from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router';
import Media from 'react-media';
import loadable from '@loadable/component';

import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import { getFeatureFlag, getFeatureFlags } from '../../../../state/ducks/App/ducks/Config/Config-Selectors';
import { setBrandMovieSkus } from '../../../../state/ducks/App/App-Actions';
import { actions as tagManagerActions } from '../../../../state/ducks/TagManager';
import CUSTOM_BREAKPOINTS from '../../../helpers/customBreakpoints';

import {
    getOrderId,
    getOrderItemIds,
    getCartCount,
    getOrderItemExcludePassportAndDonation,
    getOrderContainsSubscriptionItem,
} from '../../../../state/ducks/Common/Common-Selectors';
import { getIsAuthenticatedStatus } from '../../../../state/ducks/Member/ducks/Common/Common-Selectors';
import { triggerInterstitialLogin } from '../../../../state/ducks/Member/ducks/Auth/Auth-Actions';
import {
    clearAddToCartError,
    addUpsellsToCart,
} from '../../../../state/ducks/AddToCart/AddToCart-Actions';
import { getAddToCartError, getLastAddedOrderItemDetails } from '../../../../state/ducks/AddToCart/AddToCart-Selectors';
import { getCartAttributeByNameAndReturnValue } from '../../../helpers/page/pageHelpers';

const LoadableMobileAddonsUi = loadable(() => import(/* webpackChunkName: "MobileAddonsUi" */ './Partials/MobileAddonsUI'));
const LoadableDesktopAddonsUi = loadable(() => import(/* webpackChunkName: "DesktopAddonsUi" */ './Partials/DesktopAddonsUi'));
const LoadableAddonsDetailPage = loadable(() => import(/* webpackChunkName: "AddonsNewUI" */ './Partials/AddonsDetailPage'));

// convert to useStyles
const styles = (theme) => ({
    root: {
        width: '100%',
        marginBottom: '70px',
        [theme?.breakpoints?.down('md')]: {
            padding: '0 10px',
        },
    },
    addonWrapper: {
        margin: '0 auto',
        width: '100%',
        maxWidth: '1400px',
        background: theme?.palette?.white,
        minHeight: '200px',
        flexFlow: 'row wrap',
        justifyContent: 'flex-start',
    },
    titleProd: {
        fontSize: '18px',
        fontWeight: '700',
        margin: '12px 0 5px',
    },
    containerBtnCheckout: {
        flexFlow: 'row wrap',
        justifyContent: 'flex-end',
        minHeight: 55,
    },
    buttonCheckout: {
        margin: '0',
        display: 'block',
        width: 'auto',
        height: '50px',
        color: theme?.palette?.white,
        textAlign: 'center',
        lineHeight: '20px',
        backgroundColor: theme.palette.cms?.primary || theme.palette.colorPrimary,
        borderRadius: '4px',
        cursor: 'pointer',
        fontWeight: '600',
        fontSize: '18px',
        padding: '0 30px',
        textTransform: 'uppercase',
        '&:hover, &:focus, &:active': {
            backgroundColor: theme.palette.cms?.primary || theme.palette.colorPrimary,
        },
        [theme?.breakpoints?.down('md')]: {
            fontSize: '16px',
        },
    },
    buttonContinue: {
        margin: '10px auto',
        display: 'block',
        width: '100%',
        maxWidth: '280px',
        height: '44px',
        color: theme?.palette?.white,
        textAlign: 'center',
        lineHeight: '16px',
        backgroundColor: theme?.palette?.primaryButton,
        borderRadius: '4px',
        cursor: 'pointer',
        fontWeight: '500',
        fontSize: '16px',
        textTransform: 'uppercase',
        '&:hover, &:focus, &:active': {
            backgroundColor: theme?.palette?.primaryButton,
        },
        [theme?.breakpoints?.down('md')]: {
            fontSize: '16px',
        },
    },
    buttonContinueShopping: {
        margin: '0 auto',
        display: 'block',
        width: '240px',
        height: '30px',
        color: theme.palette.cms?.primary || theme.palette.colorPrimary,
        textDecoration: 'underline',
        textAlign: 'center',
        lineHeight: '16px',
        backgroundColor: theme?.palette?.white,
        borderRadius: '4px',
        cursor: 'pointer',
        fontWeight: '500',
        fontSize: '14px',
        textTransform: 'none',
        padding: '10px 15px',
        '&:hover, &:focus, &:active': {
            backgroundColor: theme?.palette?.white,
            color: theme.palette.cms?.primary || theme.palette.colorPrimary,
            textDecoration: 'underline',
        },
        [theme?.breakpoints?.down('md')]: {
            fontSize: '16px',
        },

    },
    textOr: {
        margin: '20px auto',
        display: 'block',
        width: '100%',
        lineHeight: '60px',
        textAlign: 'center',
        fontWeight: '500',
    },
    titleAddon: {
        borderBottom: `2px solid ${theme.palette.cms?.primary || theme.palette.colorPrimary}`,
        fontWeight: '600',
        fontSize: '18px',
        padding: '5px 0',
        margin: '15px 0 10px',
    },
    titleAddonMobile: {
        borderBottom: `2px solid ${theme.palette.cms?.primary || theme.palette.colorPrimary}`,
        fontWeight: '600',
        fontSize: '16px',
        margin: '0px',
        textAlign: 'center',
        textTransform: 'uppercase',
        color: theme.palette.cms?.primary || theme.palette.colorPrimary,
    },
    icon: {
        verticalAlign: 'middle',
    },
    errorMsg: {
        color: theme?.palette?.error?.main,
        padding: '1% 0%',
        width: '100%',
        wordWrap: 'break-word',
        display: 'inline-block',
        textAlign: 'center',
    },
    buttonCheckoutMobile: {
        width: '100%',
        fontSize: '18px',
        fontWeight: '500',
        color: '#fff',
        backgroundColor: theme.palette.primaryButton,
        padding: '15px 0px',
        margin: '15px',
        '&:hover, &:focus, &:active': {
            backgroundColor: theme.palette.primaryButton,
            color: theme?.palette?.white,
        },
    },
    buttonCheckoutMobileRedesign: {
        textTransform: 'none',
        position: 'fixed',
        bottom: '0',
        zIndex: '1',
        width: '92%',
        fontSize: '18px',
        fontWeight: '500',
        color: '#fff',
        backgroundColor: theme.palette.primaryButton,
        padding: '15px 0px',
        margin: '0 15px',
        '&:hover, &:focus, &:active': {
            backgroundColor: theme.palette.primaryButton,
            color: theme?.palette?.white,
        },
    },
    titleSlider: {
        lineHeight: '36px',
        fontSize: '24px',
        margin: '16px 0px',
        display: 'flex',
    },
    subTitleSlider: {
        lineHeight: '23px',
        fontSize: '18px',
        padding: '0px 0 5px',
        borderBottom: `2px solid ${theme.palette.cms?.primary || theme.palette.colorPrimary}`,
        [theme?.breakpoints?.down(600)]: {
            lineHeight: '21px',
            fontSize: '16px',
            textAlign: 'center',
        },
    },
    headingAddon: {
        fontSize: '18px',
        padding: '5px 0',
        margin: '15px 0 0px',
        [theme?.breakpoints?.down(600)]: {
            fontSize: '16px',
            textAlign: 'center',
        },
    },
});

// migrate to functional component
class AddOnsPageBuilder extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // TODO simplify data flow so local state is not required
            selectedItems: {},
            selectedWrapupItems: {},
            // New design support
            openModal: false,
            modalItemList: [],
            typeItem: '',
            groupItemId: '',
            groupItemName: '',
        };
    }

    componentDidMount() {
        const {
            callClearAddToCartError, actionSetBrandMovieSkus, wrapupContent, flags, trackEvent, wrapupAddonRedesign,
        } = this.props;
        callClearAddToCartError();
        // retrives cart on mount so the relevent order details are saved in and accessible from redux
        const movieSkus = {};
        if (wrapupContent.length) {
            wrapupContent.forEach((wrapUpItem) => {
                if (wrapUpItem?.sku?.parentProduct?.categories?.includes('digital_products') || wrapUpItem.sku?.name?.toLowerCase()?.includes('digital movie gift')) {
                    // Starting at the end of the string (backwards pattern matching), continue to match any characters that aren't '-' or '_'
                    movieSkus[wrapUpItem.skuPartNumber.match(/[^-_]*$/)] = true;
                }
            });
            if (Object.keys(movieSkus).length) {
                actionSetBrandMovieSkus(movieSkus);
            }
        }

        if (wrapupAddonRedesign) {
            trackEvent({
                eventCategory: 'Experiment',
                eventAction: 'Addon',
                eventLabel: 'Variant',
            });
        } else {
            trackEvent({
                eventCategory: 'Experiment',
                eventAction: 'Addon',
                eventLabel: 'Control',
            });
        }
    }

    addingAddonsToCart = () => {
        const {
            history,
            lastAddedOrderItem, actionAddUpsellsToCart,
        } = this.props;

        // TODO: Look with the new service car to delete the old addons, also review the sagas
        // to see what is the better place to delete it
        const cartItemId = lastAddedOrderItem.cartItemId;
        const payload = {
            cartItemId,
            products: this.generateProductArray('ADDON'),
        };

        actionAddUpsellsToCart(payload, history);
    }

    addingWrapupsToCart = () => {
        const {
            history, lastAddedOrderItem, actionAddUpsellsToCart,
        } = this.props;
        const cartItemId = lastAddedOrderItem.cartItemId;
        const payload = {
            cartItemId,
            products: this.generateProductArray('WRAPUP'),
        };

        actionAddUpsellsToCart(payload, history);
    }

    addingAddonsAndWrapupToCart = () => {
        const {
            lastAddedOrderItem,
            actionAddUpsellsToCart,
            history,
        } = this.props;
        const cartItemId = lastAddedOrderItem.cartItemId;
        const addon = this.generateProductArray('ADDON');
        const wrapup = this.generateProductArray('WRAPUP');
        const products = [...addon, ...wrapup];
        const payload = {
            cartItemId,
            products,
        };

        actionAddUpsellsToCart(payload, history);
    }

    generateProductArray = (type) => {
        if (type === '') return [];
        const productItems = [];
        if (type === 'ADDON') {
            const { selectedItems } = this.state;
            Object.keys(selectedItems).forEach((groupId) => {
                selectedItems[groupId].map((addon) => {
                    const productCodeArray = addon?.partNumber.split('-');
                    const productCode = productCodeArray?.[1] || '';
                    productItems.push({
                        lineItemType: 'ADDON',
                        addon: true,
                        baseCode: groupId,
                        brandCode: addon?.brandId,
                        price: addon?.prices?.[1]?.value || addon?.prices?.[0]?.value,
                        productCode,
                        productId: '',
                        quantity: '1',
                        partNumber: addon?.partNumber,
                        name: addon?.name,
                    });
                });
            });
        } else if (type === 'WRAPUP') {
            const { selectedWrapupItems } = this.state;
            const {
                lastAddedOrderItem,
                wrapupContent,
            } = this.props;
            const categoryUrlOfLastAddedItem = getCartAttributeByNameAndReturnValue(lastAddedOrderItem?.attributes || [], 'categoryPath');
            Object.keys(selectedWrapupItems).map((sku) => {
                const productCodeArray = selectedWrapupItems[sku]?.skuInfo?.id.split('-');
                const productCode = productCodeArray?.[1] || '';
                const filteredWrapupItem = wrapupContent?.find((wrapUpItem) => wrapUpItem?.sku?.id === selectedWrapupItems[sku]?.skuInfo?.id);
                const productItem = {
                    lineItemType: 'WRAPUP',
                    addon: false,
                    baseCode: filteredWrapupItem?.sku?.parentProduct?.partNumber || selectedWrapupItems[sku]?.skuInfo?.parentProduct?.partNumber,
                    brandCode: selectedWrapupItems[sku]?.skuInfo?.brandId,
                    price: selectedWrapupItems[sku]?.skuInfo?.prices?.[1]?.value || selectedWrapupItems[sku]?.skuInfo?.prices?.[0]?.value,
                    productCode,
                    productId: '',
                    quantity: '1',
                    name: selectedWrapupItems[sku]?.skuInfo?.name,
                    partNumber: selectedWrapupItems[sku]?.skuInfo?.id,
                };

                // The products only needs firstname, lastname and email,
                // without send emails at the end of place order (example: market place vendor)
                if (
                    selectedWrapupItems[sku]?.skuInfo?.parentProduct?.categories?.includes('digital_delivery')
                ) {
                    productItem.lineItemType = 'DDELVR';
                }

                if (
                    selectedWrapupItems[sku]?.skuInfo?.parentProduct?.categories?.includes('digital_products')
                    || selectedWrapupItems[sku]?.skuInfo?.name?.toLowerCase()?.includes('digital movie gift')
                ) {
                    // if the wrapup item is a movie item then add below lineItemType to
                    // correctly calculate tax
                    productItem.lineItemType = 'NBCU';
                }

                if (typeof categoryUrlOfLastAddedItem === 'string') {
                    productItem.attributes = [
                        {
                            attributeName: 'categoryPath',
                            attributeValue: categoryUrlOfLastAddedItem,
                        },
                    ];
                }
                productItems.push(productItem);
            });
        }
        return productItems;
    }

    removeItems = (itemDetails, groupId, groupName) => {
        const { trackEvent } = this.props;
        const { selectedItems } = this.state;
        // Create a copy of selectedItems from state to prevent direct state mutation.
        const newSelectedItems = { ...selectedItems };
        // Check if the entire group (parent ID array) exists
        if (newSelectedItems[groupId]) {
            // If the group exists, remove the entire group
            delete newSelectedItems[groupId];
        }
        const eventName = newSelectedItems[groupId] ?  'add_product' : 'remove_product';
        const eventAction = newSelectedItems[groupId] ?  'Product AddOn Selected' : 'Product AddOn Removed';
        // Track event
        trackEvent({
            eventName,
            eventCategory: 'Shopping',
            eventAction,
            eventLabel: itemDetails.name,
            products: [
                {
                    ...itemDetails,
                    name: groupName,
                    categoryName: 'AddOns',
                    categoryPath: '/add-ons',
                },
            ],
        });

        this.setState({
            selectedItems: newSelectedItems,
        });
    };

    selectItems = (itemDetails, groupId, groupName) => {
        const { trackEvent } = this.props;
        const { selectedItems } = this.state;
        // The following line makes a replica of selectedItems from state to prevent direct state mutation.
        const newSelectedItems = Object.assign(selectedItems);

        // Add / Remove addons multiples
        // Add addons
        if (!newSelectedItems[groupId]) {
            newSelectedItems[groupId] = [];
        }

        // Remove the addon if is unselected
        let keyPosition = -1;
        selectedItems[groupId].forEach((item, keyItem) => {
            if (selectedItems[groupId][keyItem]?.id === itemDetails.id) {
                keyPosition = keyItem;
            }
        });

        if (keyPosition > -1) {
            // if the addon is unselecte and the only one item in that current selected for the group
            // remove the full group.

            if (newSelectedItems[groupId]?.length === 1) {
                delete newSelectedItems[groupId];
            } else {
                // Remove the addon unselected from the group
                delete newSelectedItems[groupId].splice(keyPosition, 1);
            }
        } else {
            // Add the addon if is selected
            newSelectedItems[groupId].push({
                ...itemDetails,
                groupName,
            });
        }
        const getSelectedItem = newSelectedItems[groupId]?.some((item) => item?.id === itemDetails?.id);
        const eventName = getSelectedItem ? 'add_product' : 'remove_product';
        const eventAction = getSelectedItem ?  'Product AddOn Selected' : 'Product AddOn Removed';
        // Track event
        trackEvent({
            eventName,
            eventCategory: 'Shopping',
            eventAction,
            eventLabel: itemDetails.name,
            products: [
                {
                    ...itemDetails,
                    name: groupName,
                    categoryName: 'AddOns',
                    categoryPath: '/add-ons',
                },
            ],
        });

        this.setState({
            selectedItems: newSelectedItems,
        });
    };

    selectWrapupItems = (skuInfo) => {
        const { trackEvent } = this.props;
        const { selectedWrapupItems } = this.state;
        const newSelectedWrapupItems = Object.assign(selectedWrapupItems);
        if (newSelectedWrapupItems?.[skuInfo?.id]) {
            delete newSelectedWrapupItems[skuInfo.id];
        } else {
            newSelectedWrapupItems[skuInfo.id] = {
                skuInfo,
            };
        }
        const eventName = newSelectedWrapupItems?.[skuInfo?.id] ?  'add_product' : 'remove_product';
        const eventAction = newSelectedWrapupItems?.[skuInfo?.id] ?  'Product Wrapup Selected' : 'Product Wrapup Removed';
        // Track event
        trackEvent({
            eventName,
            eventCategory: 'Shopping',
            eventAction,
            eventLabel: skuInfo.name,
            products: [
                {
                    ...skuInfo,
                    name: skuInfo.name,
                    categoryName: 'Wrapups',
                    categoryPath: '/add-ons',
                },
            ],
        });

        this.setState({
            selectedWrapupItems: newSelectedWrapupItems,
        });
    };

    handleOpenModal = (type, itemList, groupItemId, groupItemName, typeBtn) => {
        const { trackEvent, flags, wrapupAddonRedesign } = this.props;
        if (wrapupAddonRedesign) {
            trackEvent({
                eventCategory: 'Experiment',
                eventAction: type,
                eventLabel: `${typeBtn} ${groupItemId}`,
            });
        }
        this.setState({
            openModal: true,
            modalItemList: itemList,
            typeItem: type,
            groupItemId,
            groupItemName,
        });
    }

    handleCloseModal = () => {
        this.setState({
            openModal: false,
            modalItemList: {},
            typeItem: '',
            groupItemId: '',
        });
    }

    handleClick = () => {
        const {
            orderId, orderContainsSubscriptionItem, isAuthenticated, actionTriggerInterstitialLogin,
            history, cartCount, isSubscriptionInterstitialLoginEnabled, featureFlags,
        } = this.props;
        const { selectedItems, selectedWrapupItems } = this.state;
        // If user has selected addons to addon add to cart call
        if (orderId !== '' && (Object.keys(selectedItems).length > 0 || Object.keys(selectedWrapupItems).length > 0)) {
            if (Object.keys(selectedItems).length > 0 && Object.keys(selectedWrapupItems).length > 0) {
                this.addingAddonsAndWrapupToCart();
            } else if (Object.keys(selectedItems).length > 0) {
                this.addingAddonsToCart();
            } else if (Object.keys(selectedWrapupItems).length > 0) {
                this.addingWrapupsToCart();
            }
        // This check is repeated in GraphqlAddOnContentContainer.js
        } else if (orderContainsSubscriptionItem.length > 0 && isSubscriptionInterstitialLoginEnabled && !isAuthenticated) {
            actionTriggerInterstitialLogin(history, true);
        } else if ((featureFlags['is-interstitial-login-enabled'] || featureFlags['is-native-interstitial-page-enabled']) && !isAuthenticated) {
            actionTriggerInterstitialLogin(history);
        } else if (orderId !== '') {
            // If user has not selected any addons go straight to cart
            if (cartCount > 1) {
                history.push(`/checkout/cart/${orderId}`);
            } else {
                history.push(`/checkout/shipping/${orderId}`);
            }
        } else if (!orderId) {
            // If someone is directly linked to /add-ons and clicks continue without anything in cart
            // they are redirected to the homepage instead of an empty cart
            history.push('/');
        }
    }

    getSelectAddonsByGroup = (data) => {
        const { selectedItems } = this.state;
        let selectedGroupId = '';
        const listSelectedItem = [];

        Object.keys(selectedItems).forEach((groupId) => {
            if (groupId === data.id) {
                selectedItems[groupId].forEach((item) => {
                    listSelectedItem.push(item.partNumber);
                });
            }
        });

        if (Object.keys(selectedItems).length > 0) { // state object for selected is not 0
            selectedGroupId = data.addons
                .map((item) => item)
                .filter((item) => listSelectedItem.includes(item.id));
            if (selectedGroupId.length > 0) {
                selectedGroupId = selectedGroupId[0]?.id;
            }
            if (selectedGroupId.length === 0) {
                selectedGroupId = '';
            }
        }
        return selectedGroupId;
    }

    getSelectWrapupByGroup = (wrapupData) => {
        const { selectedWrapupItems } = this.state;
        const selectedWrapups = []; // array of strings of skus
        let selectedWrapupItemId = '';
        Object.keys(selectedWrapupItems).forEach((sku) => {
            selectedWrapups.push(sku);
        });
        // passing the item seleted item id
        if (Object.keys(selectedWrapupItems).length > 0) { // state object for selected is not 0
            const selected = selectedWrapups.filter((item) => item === wrapupData?.sku?.id);
            if (selected !== null) {
                selectedWrapupItemId = selected[0];
            }
            if (!selectedWrapupItemId) {
                selectedWrapupItemId = '';
            }
        }
        return selectedWrapupItemId;
    }

    render() {
        const {
            classes, content, wrapupContent, addToCartError, orderItems, wrapUpHeaderInfo,
            breakpoint, lastAddedOrderItem, addOnData, flags,
            sympathyValue, showWrapupProductsOnAddOnPage, addOnHoverInfo, wrapUpInfo, featureFlags, wrapupAddonRedesign,
        } = this.props;
        const {
            selectedItems, selectedWrapupItems, openModal, modalItemList,
            typeItem, groupItemId, groupItemName,
        } = this.state;

        const productDetails = lastAddedOrderItem;
        const breakpointExpr =  `(max-width: ${(breakpoint || CUSTOM_BREAKPOINTS.tabPortrait)}px)`;

        let selectedItemsModal = [];
        if (typeItem === 'addons' && selectedItems && selectedItems[groupItemId]) {
            selectedItemsModal = selectedItems[groupItemId];
        } else if (typeItem === 'wrapup' && selectedWrapupItems && selectedWrapupItems[groupItemId]) {
            selectedItemsModal = selectedWrapupItems[groupItemId].skuInfo;
        }
        let titleAddons = 'Make your gift extra special';
        if (sympathyValue) {
            titleAddons = 'Add To Your Order';
        } else if (wrapupAddonRedesign) {
            titleAddons = 'Make This Gift Extra Special';
        }
        if (wrapupAddonRedesign) {
            return (
                <LoadableAddonsDetailPage
                    addOnData={addOnData}
                    addOnHoverInfo={addOnHoverInfo}
                    addToCartError={addToCartError}
                    content={content}
                    getSelectAddonsByGroup={this.getSelectAddonsByGroup}
                    getSelectWrapupByGroup={this.getSelectWrapupByGroup}
                    groupItemId={groupItemId}
                    groupItemName={groupItemName}
                    handleClick={this.handleClick}
                    handleCloseModal={this.handleCloseModal}
                    handleOpenModal={this.handleOpenModal}
                    modalItemList={modalItemList}
                    openModal={openModal}
                    orderItems={orderItems}
                    productDetails={productDetails}
                    selectedItems={selectedItems}
                    selectedItemsModal={selectedItemsModal}
                    selectedWrapupItems={selectedWrapupItems}
                    selectItems={this.selectItems}
                    selectWrapupItems={this.selectWrapupItems}
                    showWrapupProductsOnAddOnPage={showWrapupProductsOnAddOnPage}
                    sympathyValue={sympathyValue}
                    titleAddons={titleAddons}
                    typeItem={typeItem}
                    wrapupContent={wrapupContent}
                    wrapUpInfo={wrapUpInfo}
                    flags={featureFlags}
                    removeItems={this.removeItems}
                    wrapupAddonRedesign={wrapupAddonRedesign}
                    wrapUpHeaderInfo={wrapUpHeaderInfo}
                />
            );
        }
        return (
            <Media
                query={breakpointExpr}
            >
                {(matches) => (
                    matches ? (
                        <LoadableMobileAddonsUi
                            addOnData={addOnData}
                            addOnHoverInfo={addOnHoverInfo}
                            classes={classes}
                            content={content}
                            getSelectAddonsByGroup={this.getSelectAddonsByGroup}
                            handleClick={this.handleClick}
                            selectItems={this.selectItems}
                            selectWrapupItems={this.selectWrapupItems}
                            getSelectWrapupByGroup={this.getSelectWrapupByGroup}
                            sympathyValue={sympathyValue}
                            titleAddons={titleAddons}
                            wrapupContent={wrapupContent}
                            wrapUpInfo={wrapUpInfo}
                            flags={featureFlags}
                            wrapUpHeaderInfo={wrapUpHeaderInfo}
                            addToCartError={addToCartError}
                        />
                    ) : (
                        <LoadableDesktopAddonsUi
                            addOnData={addOnData}
                            addOnHoverInfo={addOnHoverInfo}
                            addToCartError={addToCartError}
                            classes={classes}
                            content={content}
                            getSelectAddonsByGroup={this.getSelectAddonsByGroup}
                            getSelectWrapupByGroup={this.getSelectWrapupByGroup}
                            groupItemId={groupItemId}
                            groupItemName={groupItemName}
                            handleClick={this.handleClick}
                            handleCloseModal={this.handleCloseModal}
                            handleOpenModal={this.handleOpenModal}
                            modalItemList={modalItemList}
                            openModal={openModal}
                            orderItems={orderItems}
                            productDetails={productDetails}
                            selectedItems={selectedItems}
                            selectedItemsModal={selectedItemsModal}
                            selectedWrapupItems={selectedWrapupItems}
                            selectItems={this.selectItems}
                            selectWrapupItems={this.selectWrapupItems}
                            showWrapupProductsOnAddOnPage={showWrapupProductsOnAddOnPage}
                            sympathyValue={sympathyValue}
                            titleAddons={titleAddons}
                            typeItem={typeItem}
                            wrapupContent={wrapupContent}
                            wrapUpInfo={wrapUpInfo}
                            flags={featureFlags}
                            wrapUpHeaderInfo={wrapUpHeaderInfo}
                        />
                    )
                )}
            </Media>
        );
    }
}

AddOnsPageBuilder.propTypes = {
    addToCartError: string,
    cartCount: number.isRequired,
    classes: object.isRequired,
    content: array.isRequired,
    wrapupContent: array,
    history: object.isRequired,
    orderId: string.isRequired,
    // orderItemIds: array,
    callClearAddToCartError: func.isRequired,
    orderItems: array.isRequired,
    trackEvent: func.isRequired,
    actionAddUpsellsToCart: func.isRequired,
    isSubscriptionInterstitialLoginEnabled: bool.isRequired,
    breakpoint: number,
    lastAddedOrderItem: object.isRequired,
    actionSetBrandMovieSkus: func.isRequired,
    actionTriggerInterstitialLogin: func.isRequired,
    isAuthenticated: bool,
    orderContainsSubscriptionItem: array,
    addOnData: arrayOf(arrayOf(shape({
        sku: string.isRequired,
        nbcu_see_titles: string.isRequired,
        info_on_hover: string.isRequired,
    }))).isRequired,
    addOnHoverInfo: arrayOf(shape({
        info_on_hover: string,
        product_sku_part_numbers: string,
        see_more_info: string,
    })).isRequired,
    sympathyValue: bool,
    showWrapupProductsOnAddOnPage: string,
    wrapUpInfo: arrayOf(shape({
        sku: string.isRequired,
        info_on_hover: string.isRequired,
    })).isRequired,
    featureFlags: object.isRequired,
    flags: object,
    wrapupAddonRedesign: bool,
    wrapUpHeaderInfo: object.isRequired,
};

AddOnsPageBuilder.defaultProps = {
    wrapupContent: [],
    addToCartError: '',
    breakpoint: CUSTOM_BREAKPOINTS.tabPortrait,
    isAuthenticated: false,
    orderContainsSubscriptionItem: [],
    sympathyValue: false,
    showWrapupProductsOnAddOnPage: 'false',
    flags: {},
    wrapupAddonRedesign: false,
};

// Remove / convert to hooks/props
const mapDispatchToProps = (dispatch) => ({
    callClearAddToCartError: bindActionCreators(clearAddToCartError, dispatch),
    trackEvent: bindActionCreators(tagManagerActions.trackEvent, dispatch),
    actionAddUpsellsToCart: bindActionCreators(addUpsellsToCart, dispatch),
    actionSetBrandMovieSkus: bindActionCreators(setBrandMovieSkus, dispatch),
    actionTriggerInterstitialLogin: bindActionCreators(triggerInterstitialLogin, dispatch),
});

const mapStateToProps = (state) => ({
    addToCartError: getAddToCartError(state),
    cartCount: getCartCount(state),
    orderId: getOrderId(state),
    orderItemIds: getOrderItemIds(state),
    orderItems: getOrderItemExcludePassportAndDonation(state),
    lastAddedOrderItem: getLastAddedOrderItemDetails(state),
    isSubscriptionInterstitialLoginEnabled: getFeatureFlag('is-subscription-interstitial-login-enabled')(state),
    orderContainsSubscriptionItem: getOrderContainsSubscriptionItem(state),
    isAuthenticated: getIsAuthenticatedStatus(state),
    featureFlags: getFeatureFlags(state),
});
const enhance = compose(
    withLDConsumer(),
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(styles),
    withRouter,
);

export default enhance(AddOnsPageBuilder);
